/*
 * Put-order.ts
 * Description: Includes the declaration
 * of the update order function
 */

// Importing Axios for HTTP request
import Axios from 'axios';
// Importing variables
import {APIURL} from '@/ts/variables';

/**
 * Updating an order
 *
 * @return {Object} Promise - a list of all municipalities
 * @param {Number} id - id of an order
 * @param {String} status - the status of an order
 * @param {String} slug - id of a restaurant
 */
export function putOrder(id: number, slug: string, status: string) {
    const jwt = localStorage.getItem('jwt');
    // pagination.loading = true;
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        // Using Axios to send the request
        Axios({
            url: APIURL + 'restaurants/' + slug + '/orders/' + id,
            method: 'put',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data: {
                status,
            },
        }).then(() => {
            resolve();
        }).catch(() => {
            reject();
        });
    });
}
